import { AfterViewInit, Component, HostListener, Input, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { IClickablePanel } from '@shared/types/common.types';
import { Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'app-click-share-wrapper',
  templateUrl: './click-share-wrapper.component.html',
  styleUrls: ['./click-share-wrapper.component.scss'],
})
export class ClickShareWrapperComponent implements AfterViewInit {
  @Input() parentPanel: IClickablePanel;
  @Input() id: string;
  closeChild$ = new Subject<string>();

  constructor() {}

  ngAfterViewInit() {
    if (this.parentPanel?.childClick$) {
      this.parentPanel.childClick$
        .asObservable()
        .pipe(
          untilDestroyed(this),
          filter((id) => (id && id !== this.id) || id === ''),
        )
        .subscribe({
          next: (data) => {
            // console.log(this.id, 'Wrapper said close child', data);
            this.closeChild$.next(data);
          },
        });
    }
  }

  @HostListener('click', ['$event'])
  onClick(e) {
    e.stopPropagation();
    this.parentPanel.childClick$.next(this.id);
  }
}
